var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2762 9.15125C6.6345 8.80674 7.20424 8.81791 7.54875 9.1762L12 13.9015L16.4513 9.1762C16.7958 8.81791 17.3655 8.80674 17.7238 9.15125C18.0821 9.49577 18.0933 10.0655 17.7487 10.4238L12.6488 15.8238C12.4791 16.0003 12.2448 16.1 12 16.1C11.7552 16.1 11.5209 16.0003 11.3513 15.8238L6.25125 10.4238C5.90674 10.0655 5.91791 9.49577 6.2762 9.15125Z",
    fill: "#434546"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.84e1ebc8ae966e20b4bc413aeddbf5fe.svg";
export { ForwardRef as ReactComponent };